import { GenericDataApi } from '@/lib/data/GenericDataApi';
import {
    ShiftWindowQueryResponse,
    ShiftWindowOffsetQueryResponse, GetEquipmentDowntimeForShiftWindowResponse,
    ShiftLocationRefreshQueryResponse,
    ShiftEquipmentRefreshQueryResponse,
    AllShiftEquipmentRefreshQueryResponse
} from '@/models/api';
import AppHttp from '../AppHttp';

export class ShiftWindowApi extends GenericDataApi<any> {
    constructor() {
        super('ShiftWindow');
    }

    public async getShiftWindowOffset(
        mineAreaId: string,
        departmentId: string,
        date: string,
        number: string,
        offset: number,
    ): Promise<ShiftWindowOffsetQueryResponse> {
        const params = {
            mineAreaId,
            departmentId,
            date,
            number,
            offset,
        } as any;

        const response = await AppHttp.get(`${this.resource}/offset?${new URLSearchParams(params).toString()}`);
        return response ? response.data : null;
    }

    public async getShiftLocationRefresh(
        mineAreaId: string,
        departmentId: string,
        date: string,
        number: string,
        locationId: string,
        offset: number,
    ): Promise<ShiftLocationRefreshQueryResponse> {
        const params = {
            mineAreaId,
            departmentId,
            date,
            number,
            locationId,
            offset,
        } as any;

        const response = await AppHttp.get(`${this.resource}/location?${new URLSearchParams(params).toString()}`);
        return response ? response.data : null;
    }

    public async getShiftEquipmentRefresh(
        mineAreaId: string,
        departmentId: string,
        date: string,
        number: string,
        equipmentId: string,
        offset: number,
    ): Promise<ShiftEquipmentRefreshQueryResponse> {
        const params = {
            mineAreaId,
            departmentId,
            date,
            number,
            equipmentId,
            offset,
        } as any;

        const response = await AppHttp.get(`${this.resource}/equipment?${new URLSearchParams(params).toString()}`);
        return response ? response.data : null;
    }

    public async getAllShiftEquipmentRefresh(
        mineAreaId: string,
        departmentId: string,
        date: string,
        number: string,
        offset: number,
    ): Promise<AllShiftEquipmentRefreshQueryResponse> {
        const params = {
            mineAreaId,
            departmentId,
            date,
            number,
            offset,
        } as any;

        const response = await AppHttp.get(`${this.resource}/allEquipment?${new URLSearchParams(params).toString()}`);
        return response ? response.data : null;
    }

    public async getEquipmentDowntimeWindow(
        mineAreaId: string,
        departmentId: string,
        date: string,
        number: string,
        offsetPrior: number,
        offsetFollowing: number
    ): Promise<GetEquipmentDowntimeForShiftWindowResponse> {
        const params = {
            mineAreaId,
            departmentId,
            date,
            number,
            offsetPrior,
            offsetFollowing
        } as any;

        const response = await AppHttp.get(`${this.resource}/EquipmentDowntime?${new URLSearchParams(params).toString()}`);
        return response ? response.data : null;
    }
}

export default new ShiftWindowApi();
